<template>
    <div>
        <b-input-group prepend="Customer ID:" class="mb-3">
            <b-input v-model="enteredCustomerId"
                      type="text"
                      placeholder="..."
                     @keyup.enter="updateCustomer()"
            />
            <template #append>
                <b-btn variant="primary" @click="updateCustomer()" @keyup.enter="updateCustomer()">Fetch</b-btn>
            </template>
        </b-input-group>

        <div v-if="customerId">
<!--            <b-input-group prepend="Company ID:" class="my-3">-->
<!--                <b-input type="text" name="company id" v-model="customerData.company_id" disabled></b-input>-->
<!--            </b-input-group>-->
            <CustomerEdit :customerId="customerId" />
        </div>
    </div>
</template>

<script>
import CustomerUsers from "@/components/dashboard/customers/CustomerUsers.vue";
import OrderCollection from "@/components/dashboard/OrderCollection.vue";
import CustomerEdit from "@/views/dashboard/Customers/CustomerEdit.vue";
export default {
    name: "CustomerAdmin",
    components: {CustomerEdit, OrderCollection, CustomerUsers},
    props: ['defaultCustomerId'],
    data: () => ({
        enteredCustomerId: null,
        customerId: null,
        companyIds: {},
    }),
    created() {
        this.customerId = this.defaultCustomerId;
        this.enteredCustomerId = this.defaultCustomerId;
    },
    methods: {
        updateCustomer() {
            this.customerId = this.enteredCustomerId;
        }
    }
}
</script>

<style scoped>

</style>